import { Cpu } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#27272A] py-8 px-4 sm:px-6 lg:px-8 bg-[#0A0A0F]">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Cpu size={16} className="text-[#22D3EE]" />
          <p className="text-sm text-[#71717A]">
            &copy; 2026 OCI Mastery Course &middot; Kanhiyalal Kushwaha
          </p>
        </div>
        <div className="flex gap-6">
          <a href="tel:+918978266997" className="text-sm text-[#71717A] hover:text-[#22D3EE] transition-colors">
            +91-8978266997
          </a>
          <a
            href="https://chat.whatsapp.com/FNEonQAoqzv3dE6VPi4JNl"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#71717A] hover:text-[#22D3EE] transition-colors"
          >
            WhatsApp
          </a>
        </div>
      </div>
    </footer>
  );
}
